import { SAVERS } from "./types";

const viewSaver = (data) => ({
  type: SAVERS.VIEW,
  payload: data,
});

const withdrawViewSaver = (data) => ({
  type: SAVERS.WITHDRAW_VIEW_SAVER,
  payload: data,
});

const viewSaverSuccess = (data) => ({
  type: SAVERS.VIEW_SUCCESS,
  payload: data,
});

const viewSaverFail = (data) => ({
  type: SAVERS.VIEW_FAIL,
  payload: data,
});

const createSaver = (data, history) => ({
  type: SAVERS.CREATE,
  payload: data,
  history
});

const countSavers = (data) => ({
  type: SAVERS.COUNT,
  payload: data,
});

const countSaversSuccess = (data) => ({
  type: SAVERS.COUNT_SUCCESS,
  payload: data,
});

const saverCreated = () => {
  return {
    type: SAVERS.SAVER_CREATED,
  };
};

const createSaverSuccess = (data) => ({
  type: SAVERS.CREATE_SUCCESS,
  payload: data,
});

const createSaverFail = (data) => ({
  type: SAVERS.CREATE_FAIL,
  payload: data,
});

const withdrawSavers = (data, history) => ({
  type: SAVERS.WITHDRAW,
  payload: data,
  history
});

const withdrawSaversSuccess = (data) => ({
  type: SAVERS.WITHDRAW_SUCCESS,
  payload: data,
});

const withdrawSaversFail = (data) => ({
  type: SAVERS.WITHDRAW_FAIL,
  payload: data,
});

const depositSavers = (data, history) => ({
  type: SAVERS.DEPOSIT,
  payload: data,
  history
});

const depositSaversSuccess = (data) => ({
  type: SAVERS.DEPOSIT_SUCCESS,
  payload: data,
});

const depositSaversFail = (data) => ({
  type: SAVERS.DEPOSIT_FAIL,
  payload: data,
});

const createGoal = (data, history) => ({
  type: SAVERS.CREATE_GOAL,
  payload: data,
  history,
});

const createGoalSuccess = (data) => ({
  type: SAVERS.CREATE_GOAL_SUCCESS,
  payload: data,
});

const createGoalFail = (data) => ({
  type: SAVERS.CREATE_GOAL_FAIL,
  payload: data,
});

const clearSavers = () => {
  return {
    type: SAVERS.CLEAR,
  };
};

const saveInfo = (data) => ({
  type: SAVERS.SAVE_INFO,
  payload: data,
});

const clearInfo = () => ({
  type: SAVERS.CLEAR_INFO,
});

const sendOtp = (data) => ({
  type: SAVERS.SEND_OTP,
  payload: data,
});

const resendOtp = (data) => ({
  type: SAVERS.RESEND_OTP,
  payload: data,
});

const viewSavers = (data) => ({
  type: SAVERS.VIEW_SAVERS,
  payload: data,
});

const viewSaversSuccess = (data) => ({
  type: SAVERS.VIEW_SAVERS_SECCESS,
  payload: data,
});

export {
  createSaver,
  createSaverSuccess,
  createSaverFail,
  withdrawSavers,
  withdrawSaversSuccess,
  withdrawSaversFail,
  depositSavers,
  depositSaversSuccess,
  depositSaversFail,
  viewSaver,
  viewSaverSuccess,
  viewSaverFail,
  createGoal,
  createGoalSuccess,
  createGoalFail,
  clearSavers,
  countSavers,
  countSaversSuccess,
  withdrawViewSaver,
  saveInfo,
  clearInfo,
  sendOtp,
  resendOtp,
  viewSavers,
  viewSaversSuccess,
};
